$(document).ready(function () {
    //slider headline
    let slider = $('.-sheadline').slick({
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        centerMode: true,
        centerPadding: '30px',
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        // autoplay: true,
        // autoplaySpeed: 3000,
        appendDots: $('.-dtheadline'),
        responsive: [{
                breakpoint: 1220,
                settings: {
                    centerPadding: '273px',
                }
            },
            {
                breakpoint: 700,
                settings: {
                    centerPadding: '80px',
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerPadding: '30px',
                }
            }
        ]
    });
    // Add custom class to next or previous slide depending on change direction
    slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        let nextIndex = currentSlide + 1; // assume moving right
        if(currentSlide-1 == nextSlide || (nextSlide+1 == slick.slideCount && currentSlide < nextSlide)) {
            nextIndex = currentSlide - 1; // nope, moving left
        }
        $(`[data-slick-index="${nextIndex}"]`).addClass('slick-target');
    });

    // clear custom class after transition
    slider.on('afterChange', () => {
        $('.slick-slide').removeClass('slick-target');
    });

    //slider new release
    $('.-srelease').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        centerMode: true,
        centerPadding: '60px',
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        responsive: [{
                breakpoint: 1220,
                settings: {
                    centerPadding: '80px',
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1020,
                settings: {
                    centerPadding: '80px',
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    centerPadding: '100px',
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerPadding: '60px',
                    slidesToShow: 1,
                }
            }
        ]
    });

    //slider best seller
    $('.-sbest').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        centerMode: true,
        centerPadding: '60px',
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1900,
                settings: {
                    centerPadding: '220px',
                    slidesToShow: 6,
                    slidesToScroll: 6,
                }
            },
            {
                breakpoint: 1400,
                settings: {
                    centerPadding: '220px',
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },{
                breakpoint: 1220,
                settings: {
                    centerPadding: '120px',
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 1020,
                settings: {
                    centerPadding: '120px',
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    centerPadding: '140px',
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerPadding: '60px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });
    function slidesToScroll() {
        if ($(window).width() >= 1000) {
            $('.-sbest').slick('slickSetOption', 'slidesToScroll', 4, true);
        } else if ($(window).width() >= 800){
            $('.-sbest').slick('slickSetOption', 'slidesToScroll', 3, true);
        } else if ($(window).width() >= 500){
            $('.-sbest').slick('slickSetOption', 'slidesToScroll', 2, true);
        } else{
            $('.-sbest').slick('slickSetOption', 'slidesToScroll', 1, true);
        }
    }
    slidesToScroll();
    $(window).on('resize', function() {
        slidesToScroll();
    });

    //slider event
    $('.-sevent').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        centerMode: true,
        centerPadding: '30px',
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [{
                breakpoint: 1220,
                settings: {
                    centerPadding: '380px',
                }
            },
            {
                breakpoint: 700,
                settings: {
                    centerPadding: '140px',
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerPadding: '30px',
                }
            }
        ]
    });
});